import { sessionStorage } from 'Utils/storage';

const CHUNK_RELOAD_KEY = 'bt-chunk-reload';

function readReloadFlag() {
    return sessionStorage.getItem(CHUNK_RELOAD_KEY) === 'true';
}

function writeReloadFlag(hasReloaded) {
    if (hasReloaded) {
        sessionStorage.setItem(CHUNK_RELOAD_KEY, 'true');
    } else {
        sessionStorage.removeItem(CHUNK_RELOAD_KEY);
    }
}

function isModuleLoadError(error) {
    if (!error) return false;

    if (error.name === 'ChunkLoadError') return true;

    const message = String(error.message || '');
    return /dynamically imported module|Importing a module script failed|Loading chunk|Loading CSS chunk/i.test(
        message,
    );
}

function reloadOnceForNewBuild() {
    if (readReloadFlag()) return false;
    writeReloadFlag(true);
    window.location.reload();
    return true;
}

export function getPage(componentImport) {
    return async () => {
        try {
            const module = await componentImport();

            if (!module || !module.default) {
                if (reloadOnceForNewBuild()) {
                    return new Promise(() => {});
                }
                throw new Error('ChunkLoadError: módulo sin export default');
            }

            writeReloadFlag(false);
            return { Component: module.default };
        } catch (error) {
            if (isModuleLoadError(error) && reloadOnceForNewBuild()) {
                return new Promise(() => {});
            }
            throw error;
        }
    };
}

export function registerChunkReloadListener() {
    window.addEventListener('vite:preloadError', (event) => {
        if (reloadOnceForNewBuild()) {
            event.preventDefault();
        }
    });
}
